import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useVerifyEmail } from "../../hooks/api/useAuth"
import Logo from "../../components/Logo";

function VerificationPage() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token");

  const { isLoading, isError, isSuccess, error } = useVerifyEmail(token);

  return (
    <div className="flex justify-center items-center min-h-screen bg-[#d0ebff] relative">

      <div className="bg-white flex items-center flex-col shadow-lg rounded-lg w-[90%] sm:w-[60%] max-w-3xl p-8 relative z-10">
        <Logo/>
        <h1 className="text-center text-3xl font-bold text-[#007acc] mt-4 mb-8">
          Verifying Your Email
        </h1>

        <div className="flex flex-col items-center">
          {isLoading && (
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-blue-400"></div>
          )}
          {isError && (
            <p className="text-red-500 mt-4">
              We couldn't verify your email. The link may have expired or is
              invalid. Please try again.
            </p>
          )}
          {isSuccess && (
            <p className="text-green-600 mt-4">Email verified successfully!</p>
          )}

          <Link
            to="/"
            className="mt-6 px-6 py-2 bg-[#00aaff] text-white rounded hover:bg-[#008ecc] transition"
          >
            Go to Home Page
          </Link>
        </div>
      </div>
    </div>
  );
}

export default VerificationPage;
